import React, { useCallback } from 'react';
import { useHistory } from 'react-router';

import { getReportList } from 'api/hs/TransactionAndLists/ReportList';
import HSTableAndPaginationAndTableContextProvider from 'Common/Table/HSTable/HSTableAndPaginationAndTableContextProvider';

import { HSTableProps } from '../../Common/Table/HSTable/hs-table.props';
import { CELL } from './COLUMS';
import ListTable from './ListTable';
import Toolbar from './Toolbar';

export default function Report() {
  const history = useHistory();
  const fetchReportList = useCallback<HSTableProps<any>['fetcher']>((page, size, sorting, extra) => {
    return getReportList(page, size, sorting === false ? 'date-DESC' : `${sorting.id as string}-${sorting.direction.toUpperCase()}`);
  }, []);
  return (
    <HSTableAndPaginationAndTableContextProvider
      fetcher={fetchReportList}
      RowProps={{ className: 'cursor-pointer' }}
      columns={CELL}
      onRowClick={row => history.push(`/transactions/employee/${row.employeeId}/report`)}>
      <Toolbar />
      <ListTable />
    </HSTableAndPaginationAndTableContextProvider>
  );
}
